<template>
<main>
  <section v-show="false" class="teacher-main-row-head">
    <div class="teacher-main-col-top">
      <router-link :to="{name: 'TeacherResources'}" class="teacher-main-green-font teacher-main-big-button">教學資源</router-link>
      <router-link :to="{name: 'TeacherMyResources'}" class="teacher-main-green-font teacher-main-big-button">我的資源</router-link>
    </div>
    <div class="teacher-main-col-lastLogin">
      <LastLogin/>
    </div>
  </section>
  <div v-show="!isLoading" class="row">
    <!-- <div v-show="false" class="teacher-main-col-mission">
      <MyClass/>
    </div> -->
    <div class="teacher-main-col-80">
      <div class="teacher-mainContent">
        <div class="teacher-main-schedule-button-group">
          <div class="teacher-main-button-gp">
            <div class="teacher-main-green-font teacher-main-big-text">教學日程</div>
          </div>
          <div v-show="false" class="teacher-main-button-gp">
            <div class="teacher-main-green-font  teacher-main-text-group">進行中</div>
            <div class=" teacher-main-text-group" style="color:#878A8B">已完成</div>
          </div>
        </div>
        <div class="teacher-row-mainContent">
          <div class="teacher-main-schedule-button-group">
            <div class="teacher-main-button-gp">
              <!-- <router-link :to="{name:'HomeDaily'}" class="teacher-main-schedule-button"  :class="{ 'active' : isDaily }">日</router-link >
              <router-link :to="{name:'HomeWeekly'}" class="teacher-main-schedule-button"  :class="{ 'active' : isWeekly }">週</router-link>
              <router-link :to="{name:'HomeMonthly'}" class="teacher-main-schedule-button"  :class="{ 'active' : isMonthly }">月</router-link> -->
              <div @click="switchDaily" class="teacher-main-schedule-button"  :class="{ 'active' : isDaily }">日</div>
              <div @click="switchWeekly" class="teacher-main-schedule-button"  :class="{ 'active' : isWeekly }">週</div>
              <div @click="switchMonthly" class="teacher-main-schedule-button"  :class="{ 'active' : isMonthly }">月</div>
            </div>
            <div class="teacher-main-button-gp">
              <md-button class="teacher-main-green-font teacher-main-schedule-date-button-group" @click="prev">&lt;</md-button>
              <md-button class="teacher-main-green-font teacher-main-schedule-date-button-group" @click="next">&gt;</md-button>
            </div>
          </div>
          <div>
            <!-- <router-view/> -->
            <Month v-if="isMonthly" :year="year" :month="month" :date="date" :missions="missionList" :key="'month'+year+month+date" v-on:loaded="isLoading = false" v-on:loading="isLoading = true"/>
            <Week v-if="isWeekly" :year="year" :month="month" :date="date" :missions="missionList" :key="'week'+year+month+date" v-on:loaded="isLoading = false" v-on:loading="isLoading = true"/>
            <Daily v-if="isDaily" :year="year" :month="month" :date="date" :missions="missionList" :key="'day'+year+month+date" v-on:loaded="isLoading = false" v-on:loading="isLoading = true"/>
          </div>
        </div>
      </div>
      <!-- <div v-show="false" class="teacher-main-flipped">
        <div class="teacher-main-green-font teacher-main-big-text">翻轉課堂模式</div>
        <FlipedClassSchedule/>
      </div> -->
    </div>
  </div>
  <Loading v-show="isLoading"></Loading>
</main>
</template>
<style lang="scss" scoped>
  .main > * {
    padding: 0 calc(var(--app-padding));
    max-width: 1024px;
    margin: 0 auto;
  }
  .teacher-main-mission-setting-btn{
    margin:0.5rem 0.8rem;
    font-weight:700;
  }
  .teacher-main-button-gp{
    display:flex;
    font-weight:500;
  }
  .teacher-main-text-group{
    display: flex;
    align-self: flex-end;
    padding:0.2rem 1rem;
  }
  .teacher-main-schedule-button{
    background-color:#D2D3D4;
    padding:0.3rem 2rem;
    margin: 0.8rem 1.2rem;
    border-radius: 0.5rem;
    font-size:1.2rem;
    font-weight: 700;
    &.active {
      background-color:#FFF;
      color: #99CB32;
    }
  }
  .teacher-main-flipped{
    margin: 2rem 0;
  }
  .teacher-main-big-button{
    background: #F9EBA5;
    font-size:1.2rem;
    font-weight:700;
    padding: 0.6rem 3rem;
    border-radius: 0.5rem;
    margin:  1rem 4rem 1rem 0;
  }
  .teacher-main-schedule-date-button-group{
    font-size: 1.8rem;
    margin: 0.5rem 0;
    padding: 0 0.5rem;
  }
  .teacher-main-light-green-font{
    color: #99CB32;
  }
  .teacher-main-green-font{
    color: #387E1E;
  }
  .teacher-main-col-80{
    width:100%;
  }
  .teacher-main-big-text{
    font-size:1.8rem;
    line-height: 1.8rem;
    font-weight:700;
    padding: 30px 0;
  }
  .teacher-main-schedule-setting-button-group{
    display:flex;
    justify-content: flex-end;
  }
  .teacher-main-schedule-button-group{
    display:flex;
    justify-content: space-between;
  }
  .teacher-row-mainContent{
    background-color: #F5F5F5;
    border-radius: 1rem;
  }
  .teacher-main-row-head{
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin: auto;
  }
  .teacher-main-col-mission{
    float: left;
    margin: 0 1rem 0 0;
  }
  .teacher-main-col-top{
    float:left;
    display: flex;
    justify-content: center;
  }
  .teacher-main-col-lastLogin{
    float:left;
  }
  .teacher-main-col-80{
    float: left;
    width:100%;
  }
  main{
    margin:auto;
  }
  .row{
    display: table;
    margin:auto;
    width:90%;
  }
  /* Clear floats after the columns */
  .row:after {
    display: flex;
    clear: both;
  }
  @media screen and (max-width: 1024px) {
    .teacher-main-row-head{
      margin: 1rem auto;
    }
  }
  @media screen and (min-width: 1024px) {
    .teacher-main-col-80{
      width: 80%;
    }
    .teacher-main-row-head{
      margin: 3rem auto;
    }
    .teacher-main-big-button{
      background: #F9EBA5;
      font-size:1.2rem;
      font-weight:700;
      padding: 0.6rem 5rem;
      border-radius: 0.5rem;
      margin:  1rem 4rem 1rem 0;
    }
    .row{
      display: flex;
      justify-content: space-between;
    }
    .teacher-main-col-top{
      margin: 0 0 2rem 0;
    }
  }
  @media screen and (max-width: 790px) {
    .teacher-main-schedule-button-group{
      display:block;
    }
  }
</style>
<script>
// import MyClass from '@/components/Teacher/Home/MyClass.vue'
// import FlipedClassSchedule from '@/components/Teacher/Home/FlipedClassSchedule.vue'
import Loading from '@/components/Utility/Loading.vue'
import LastLogin from '@/components/Home/LastLogin.vue'
import Month from '@/components/Utility/Schedule/Month'
import Week from '@/components/Utility/Schedule/Week'
import Daily from '@/components/Utility/Schedule/Daily'
export default {
  components: {
    Loading, LastLogin, Month, Week, Daily
  },
  data () {
    return {
      isLoading: true,
      today: new Date(),
      missions: [],
      isDaily: false,
      isWeekly: false,
      isMonthly: true,
      initYear: NaN,
      initMonth: NaN,
      initDate: NaN
    }
  },
  computed: {
    year: function () {
      if (!Number.isNaN(this.initYear)) {
        return this.initYear
      }
      let year = parseInt(this.$route.query.year)
      if (Number.isNaN(year)) {
        year = this.today.getFullYear()
      }
      return year
    },
    month: function () {
      if (!Number.isNaN(this.initMonth)) {
        return this.initMonth
      }
      let month = parseInt(this.$route.query.month)
      if (Number.isNaN(month)) {
        month = this.today.getMonth()
      }
      return month
    },
    date: function () {
      if (!Number.isNaN(this.initDate)) {
        return this.initDate
      }
      let date = parseInt(this.$route.query.date)
      if (Number.isNaN(date)) {
        date = this.today.getDate()
      }
      return date
    },
    cDay: function () {
      return new Date(this.year, this.month, this.date)
    },
    missionList: function () {
      return this.missions
    }
  },
  methods: {
    next: function () {
      // let name = ''
      let nextCDay = new Date(this.cDay)
      if (this.isDaily) {
        nextCDay.setTime(this.cDay.getTime() + 86400 * 1000)
        // name = 'HomeDaily'
      } else if (this.isWeekly) {
        nextCDay.setTime(this.cDay.getTime() + 86400 * 1000 * 7)
        // name = 'HomeWeekly'
      } else if (this.isMonthly) {
        nextCDay.setMonth(this.cDay.getMonth() + 1)
        // name = 'HomeMonthly'
      }
      this.initYear = nextCDay.getFullYear()
      this.initMonth = nextCDay.getMonth()
      this.initDate = nextCDay.getDate()
      // this.updateClickId()
      // window.location.reload()
    },
    prev: function () {
      // let name = ''
      let nextCDay = new Date(this.cDay)
      if (this.isDaily) {
        nextCDay.setTime(this.cDay.getTime() - 86400 * 1000)
        // name = 'HomeDaily'
      } else if (this.isWeekly) {
        nextCDay.setTime(this.cDay.getTime() - 86400 * 1000 * 7)
        // name = 'HomeWeekly'
      } else if (this.isMonthly) {
        nextCDay.setMonth(this.cDay.getMonth() - 1)
        // name = 'HomeMonthly'
      }
      this.initYear = nextCDay.getFullYear()
      this.initMonth = nextCDay.getMonth()
      this.initDate = nextCDay.getDate()
      // this.updateClickId()
      // window.location.reload()
    },
    switchDaily () {
      this.isDaily = true
      this.isWeekly = false
      this.isMonthly = false
      // return this.$route.matched.some(route => route.name === 'HomeDaily')
    },
    switchWeekly () {
      this.isDaily = false
      this.isWeekly = true
      this.isMonthly = false
      // return this.$route.matched.some(route => route.name === 'HomeWeekly')
    },
    switchMonthly () {
      this.isDaily = false
      this.isWeekly = false
      this.isMonthly = true
      // return this.$route.matched.some(route => route.name === 'HomeMonthly')
    }
  // },
  // watch: {
  //   month: function (month) {
  //     console.log('month is changed')
  //     this.$store.dispatch('request', {
  //       // route: `activities?start=${this.$refs.month.firstDay.getFullYear()}-${this.$refs.month.firstDay.getMonth() + 1}-${this.$refs.month.firstDay.getDate()}&type=weeks`
  //       route: `activities?type=weeks&month=${month + 1}`
  //     }).then(res => {
  //       this.missions = res.activities
  //     })
  //     console.log(this.$refs.month.firstDay, this.$refs.month.endDay)
  //   }
  // },
  // updated () {
  //   console.log('teacher home updated')
  //   // this.$forceUpdate()
  // },
  // async mounted () {
  //   console.log('mounted')
  //   await this.$store.dispatch('request', {
  //     // route: `activities?start=${this.$refs.month.firstDay.getFullYear()}-${this.$refs.month.firstDay.getMonth() + 1}-${this.$refs.month.firstDay.getDate()}&type=weeks`
  //     route: `activities?type=weeks&month=${this.month + 1}`
  //   }).then(res => {
  //     this.missions = res.activities
  //   })
  //   this.isLoading = false
  }
}
</script>
